<template>
  <div class="sidebar">

    <div class="navigation">
      <SidebarMenues />
    </div>

    <Settings />
    <ActivityTypes />
    <Notes />
    <TrackedRoutes />
    <MapHosts />

    <svg @click="toggleNav()" class="btn-nav">
      <use xlink:href="#direction-signs"></use>
    </svg>

  </div>
</template>

<script>
// import Menues from '@/views/Sidebar/Menues'
// //
// import Settings from '@/views/Sidebar/sections/Settings'
// import ActivityTypes from '@/views/Sidebar/sections/ActivityTypes'
// import Notes from '@/views/Sidebar/sections/Notes'
// import TrackedRoutes from '@/views/Sidebar/sections/TrackedRoutes'
// import MapHosts from '@/views/Sidebar/sections/MapHosts'

// Missing menues:
// - Page to choose a Map from (offer different map tiles)
// - Page for API keys for Map Services and Reverse Geolocation
// - Page for list of tracks / single page or one track / with export features: kml, ...
// - DB handling page: complete backup, individual store backups, delete store / db

export default {
  // components: {
  //   'my-component': () => import('./my-async-component')
  // }
  components: {
    SidebarMenues: () => import('@/views/Sidebar/SidebarMenues'),
    //
    Settings: () => import('@/views/Sidebar/sections/Settings'),
    ActivityTypes: () => import('@/views/Sidebar/sections/ActivityTypes'),
    Notes: () => import('@/views/Sidebar/sections/Notes'),
    TrackedRoutes: () => import('@/views/Sidebar/sections/TrackedRoutes'),
    MapHosts: () => import('@/views/Sidebar/sections/MapHosts')
  },
  methods: {
    toggleNav () {
      this.$store.dispatch('ui/setActiveMenu', '')
      this.$store.dispatch('ui/toggleMainNavStatus')
    }
  },
  mounted () {
    this.toggleNav()
  }
}
</script>

<style lang="postcss">
.sidebar {
  @apply fixed h-full top-0 right-0 bottom-0 z-60;
}

.navigation {
  @apply absolute top-0 right-0 bottom-0 left-auto w-12 bg-pink-800 text-pink-200;
  @apply transform translate-x-12 duration-300 ease-in-out;
  @apply shadow-md z-20;
}

.btn-nav {
  @apply text-pink-800 absolute bottom-2 right-2 w-8 h-8;
  @apply z-100 cursor-pointer;
  @apply transition duration-300 ease-in-out transform;
}

.navbar-visible .navigation {
  transform: rotateY(0);
}

.navbar-visible .btn-nav {
  color: white;
  transform: rotateY(180deg);
}
</style>
